const state = {
  filteredEntries: []
}

const mutations = {
  updateFilteredEntries (state, entries) {
    state.filteredEntries = entries
  }
}

const getters = {
  filteredEntries: state => {
    return state.filteredEntries
  }
}

export default {
  state,
  mutations,
  getters
}
